import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import withStyles from "@material-ui/core/styles/withStyles";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";

// import Favorite from "@material-ui/icons/Favorite";

import Header from "../../components/Header/Header.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

// import SectionDescription from "./Sections/SectionDescription.jsx";
import SectionTeam from "./Sections/SectionTeam.jsx";
import SectionServices from "./Sections/SectionServices.jsx";
import SectionPills from "./Sections/SectionPills";
// import SectionOffice from "./Sections/SectionOffice.jsx";
import FooterSection from "../LandingPage/Sections/FooterSection";
// import SectionContact from "./Sections/SectionContact";
import SectionSponsors from "./Sections/SectionSponsors";

import aboutUsStyle from "../../assets/jss/material-kit-pro-react/views/aboutUsStyle.jsx";

class AboutUsPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Quienes somos | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/quienes-somos" />
                    <meta name="description" content="Somos pioneros en la promoción y gestión de reservaciones online de
                    Servicios Turísticos Rurales en Colombia, damos a conocer experiencias relacionadas con el campo y sus beneficios" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />
                <Parallax image={require("../../assets/img/landing-bg.jpg")} filter="dark" small>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem md={8} sm={8} className={classNames(classes.mlAuto, classes.mrAuto, classes.textCenter)}>
                                <h1 className={classes.title}>Quienes somos</h1>
                                <h4>
                                    Conoce más acerca de nuestro proyecto
                                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        <SectionServices />
                        <SectionTeam />
                        <SectionPills />
                        <SectionSponsors/>
                    </div>
                </div>

                <FooterSection />
            </div>
        );
    }
}

export default withStyles(aboutUsStyle)(AboutUsPage);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/AboutUsPage.jsx